/* eslint-disable @typescript-eslint/no-explicit-any */
import { Parser } from 'nuqs';
import { z } from 'zod';

export type Lookup =
  | 'in'
  | 'exact'
  | 'icontains'
  | 'contains'
  | 'isnull'
  | 'startswith'
  | 'endswith'
  | 'gte'
  | 'lte';

export type BackendKey<K extends string> = K | `${K}__${Lookup}` | `${K}__${string}__${Lookup}`;

export type Connector =
  | 'filter'
  | 'filter_or'
  | 'filter_and'
  // | 'filter_and_or' // TODO: Add support for filter_and_or object
  | 'exclude'
  | 'exclude_or'
  | 'custom'
  | 'sort'
  | 'pagination'
  | 'page'; // TODO: Improve the way to handle pagination

export type BaseFilterDef<K extends string, T extends Parser<any>> = {
  key: K;
  parser: T;
  connector: Connector;
};

export type RegularFilterDef<K extends string, T extends Parser<any>> = BaseFilterDef<K, T> & {
  connector: Exclude<Connector, 'sort' | 'pagination'>;
  lookup: BackendKey<K>;
};

export type PageFilterDef = BaseFilterDef<'page', Parser<number>> & {
  connector: 'page';
};

export type SortFilterDef = BaseFilterDef<'sort', Parser<string[]>> & {
  connector: 'sort';
};

export const PaginationSchema = z.object({
  limit: z
    .number()
    .int()
    .nonnegative()
    .default(10)
    .transform((v) => v ?? 10),
  offset: z
    .number()
    .int()
    .nonnegative()
    .default(0)
    .transform((v) => v ?? 0),
});
export type PaginationType = z.infer<typeof PaginationSchema>;

export type PaginationFilterDef = BaseFilterDef<'pagination', Parser<PaginationType>> & {
  connector: 'pagination';
};

export type FilterDef<K extends string, T extends Parser<any>> =
  | RegularFilterDef<K, T>
  | SortFilterDef
  | PaginationFilterDef
  | PageFilterDef;
